class TranslatedTextModalController {

	private callback: Function; // Injected from modal-service

	public translatedText: string;

	// @ngInject
	constructor() {}

	public closeDialog = () => {
		this.close(false); // No confirm needed, just closing
	}
}

class TranslatedTextModal {
	public restrict: string = 'E';
	public scope: {};

	public bindToController = {
		translatedText: '=',
		close: '='  
	};

	public controller = TranslatedTextModalController;
	public controllerAs = 'translatedTextModal';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/translated-text-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { TranslatedTextModal };